"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _core = require("@widget-editor/core");

var _shared = require("@widget-editor/shared");

var _style = require("./style");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function resolveLabel(label, type) {
  if (type === 'date') {
    return _core.utils.parseDate(label);
  }

  return label;
}

var Legend = function Legend(_ref) {
  var widget = _ref.widget,
      advanced = _ref.advanced,
      configuration = _ref.configuration,
      scheme = _ref.scheme,
      selectedColor = _ref.selectedColor,
      columns = _ref.columns,
      patchConfiguration = _ref.patchConfiguration,
      compact = _ref.compact;

  var _widget$legend, _widget$legend$;

  var isPie = configuration.chartType === "pie";
  var multipleItems = (widget === null || widget === void 0 ? void 0 : (_widget$legend = widget.legend) === null || _widget$legend === void 0 ? void 0 : (_widget$legend$ = _widget$legend[0]) === null || _widget$legend$ === void 0 ? void 0 : _widget$legend$.values.length) > 0;
  var handleChange = (0, _react.useCallback)(function (option) {
    var color = option.identifier === "___single_color" ? null : option;

    if (isPie) {
      patchConfiguration({
        category: color
      });
    } else {
      patchConfiguration({
        color: color
      });
    }
  }, [isPie, patchConfiguration]);
  return _react["default"].createElement(_style.StyledContainer, {
    compact: compact
  }, _react["default"].createElement(_style.StyledColorsBoxContainer, {
    overflowIsHidden: multipleItems,
    alignCenter: !multipleItems
  }, !multipleItems && !advanced && _react["default"].createElement(_style.StyledColorsBox, {
    alignCenter: false
  }, _react["default"].createElement(_style.StyledColorDot, {
    color: scheme.mainColor
  }), "Single color"), multipleItems && widget.legend[0].values.map(function (item, index) {
    return _react["default"].createElement(_style.StyledColorsBox, {
      alignCenter: true,
      key: "".concat(item.label, "-").concat(index)
    }, _react["default"].createElement(_style.StyledColorDot, {
      color: item.value
    }), resolveLabel(item.label, item.type) || '−');
  })), !advanced && _react["default"].createElement(_style.StyledDropdownBox, null, _react["default"].createElement(_shared.Select, {
    align: "horizontal",
    relative: true,
    menuPlacement: "top",
    value: selectedColor,
    onChange: handleChange,
    getOptionLabel: function getOptionLabel(option) {
      return option.alias || option.name;
    },
    getOptionValue: function getOptionValue(option) {
      return option.identifier;
    },
    options: columns,
    configuration: configuration,
    isCustom: true,
    isPopup: true
  })));
};

var _default = Legend;
exports["default"] = _default;